import React from 'react';
import styles from './Reports.module.css';

const Reports: React.FC = () => {
    return (
        <div className={styles.container}>
            <h2>Reports Page</h2>
            <p>Reporting content will go here.</p>
        </div>
    );
};

export default Reports; 